import React from 'react';
import './index.scss';
import PropTypes from 'prop-types';
import PSModal from "../../PSModal";
import {Button} from "../../atoms";

const ModalCategory = React.forwardRef(({ className, title, labelButton, openModal, loading, onSave, onClose, onChange , newCategory, needFavorite}, ref) => {

    return (
      <div ref={ref}>
        <PSModal open={openModal} showCloseIcon={true} classNames={{modal:'customModalNewCategory'}} onClose={onClose}>
          <h2>{title}</h2>
          <div className={`info-container`}>
            <div className={`label-container ${needFavorite ? 'd-flex': ' '} `}>
              <label>Nombre de categoría</label>
              {
                needFavorite &&
                <input type='checkbox' onChange={(e)=>onChange(e.target.checked, 'favorite')} checked={newCategory.favorite}/>
              }
            </div>
            <input type='text' className="input-description" onChange={(e)=>onChange(e.target.value, 'description')} value={newCategory.description} />
          </div>
          <Button onClick={onSave} loading={loading}>{labelButton}</Button>
        </PSModal>
      </div>
    );
  }
);

ModalCategory.displayName = 'ModalCategory';

ModalCategory.defaultProps = {
  className: '',
  onSave: ()=>{},
  openModal: false,
  needFavorite: false,
};

ModalCategory.propTypes = {
  className: PropTypes.string,
  onSave :PropTypes.func,
  openModal: PropTypes.bool,
  needFavorite: PropTypes.bool,
};

export default ModalCategory;